import { Controller } from "@hotwired/stimulus"

// Asks the server for the rendered price breakdown whenever the renter changes
// their times or pickup mode. Deliberately knows nothing about tiers, excess
// hours or the org fallback — that ladder lives in Ruby, in one place.
export default class extends Controller {
  static targets = ["frame", "startsAt", "endsAt", "pickupMode", "vehicleId"]
  static values = { url: String, debounce: { type: Number, default: 200 } }

  connect() {
    this.refresh()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  refresh() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), this.debounceValue)
  }

  load() {
    if (!this.hasFrameTarget) return

    const params = new URLSearchParams({
      starts_at: this.startsAtTarget.value || "",
      ends_at: this.endsAtTarget.value || "",
      pickup_mode: this.pickupMode()
    })
    if (this.hasVehicleIdTarget) params.set("vehicle_id", this.vehicleIdTarget.value || "")

    this.frameTarget.src = `${this.urlValue}?${params}`
  }

  pickupMode() {
    if (!this.hasPickupModeTarget) return "branch"
    const checked = this.pickupModeTargets.find((el) => el.checked)
    return checked ? checked.value : "branch"
  }
}
